import { produce } from "immer";

import {
  ShippingsTypeActionsTypes,
  ShippingsTypeReducerActions,
  ShippingsTypeState
} from "../types/ShippingsType.reducer.types";

const INITIAL_STATE: ShippingsTypeState = {
  list: undefined,
  isLoadingList: false,
  message: undefined
};

export default function reducer(
  state = INITIAL_STATE,
  action: ShippingsTypeReducerActions
): ShippingsTypeState {
  return produce(state, draft => {
    switch (action.type) {
      case ShippingsTypeActionsTypes.CREATE_REQUEST: {
        draft.message = undefined;
        break;
      }

      case ShippingsTypeActionsTypes.CREATE_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsTypeActionsTypes.CREATE_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsTypeActionsTypes.DISMISS_MESSAGE: {
        draft.message = undefined;
        break;
      }

      case ShippingsTypeActionsTypes.EDIT_REQUEST: {
        draft.message = undefined;
        break;
      }

      case ShippingsTypeActionsTypes.EDIT_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsTypeActionsTypes.EDIT_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsTypeActionsTypes.LIST_REQUEST: {
        draft.isLoadingList = true;
        draft.list = undefined;
        break;
      }

      case ShippingsTypeActionsTypes.LIST_FAIL: {
        draft.isLoadingList = false;
        draft.list = undefined;
        break;
      }

      case ShippingsTypeActionsTypes.LIST_SUCCESS: {
        draft.isLoadingList = false;
        draft.list = action.payload.list;
        break;
      }
      default:
    }
  });
}
